import { Button, Text } from '@chakra-ui/react';
import { useDisclaimerDrawer } from '@ui/components/DisclaimerDrawer';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';

export const useUnstakeHint = (): {
  title: string;
  shortText: string;
  shortTextDesktop?: JSX.Element;
  longText: JSX.Element;
} => {
  const t = useTranslations();
  const globalCoinMode = useCoinMode();
  const info = COIN_MODE[globalCoinMode];

  const descNodes =
    globalCoinMode === 'eth'
      ? t('unstake-eth-how-it-works-desc-{br}-{SwapLink}-{NftLink}', {
          br: () => <br />,
          SwapLink: (chunk) => {
            return (
              <Button
                variant="link"
                color="text-link"
                onClick={() => {
                  useDisclaimerDrawer.getState().onOpen({
                    url: EXTERNAL_LINK.syncswapSwapToEth,
                  });
                }}
              >
                {chunk}
              </Button>
            );
          },
          NftLink: (chunk) => {
            return (
              <Button
                variant="link"
                color="text-link"
                onClick={() => {
                  useDisclaimerDrawer.getState().onOpen({
                    url: EXTERNAL_LINK.elementMarketplaceBaseUrl,
                  });
                }}
              >
                {chunk}
              </Button>
            );
          },
        })
      : t(`unstake-${globalCoinMode}-how-it-works-desc-{br}`, {
          br: () => <br />,
        });

  const descStr =
    globalCoinMode === 'eth'
      ? t('unstake-eth-how-it-works-desc-{br}-{SwapLink}-{NftLink}', {
          br: () => '',
          SwapLink: () => '',
          NftLink: () => '',
        })
      : t(`unstake-${globalCoinMode}-how-it-works-desc-{br}`, {
          br: () => '',
        });

  return {
    title: t('Unstake {coin}', {
      coin: `${info.liquidName} & NFTs`,
    }),
    longText: <>{descNodes}</>,
    shortText: descStr.slice(0, 64) + '...',
    shortTextDesktop: (
      <>
        <Text color="black" fontWeight="bold" display="inline">
          {t('Unstake')}:{' '}
        </Text>
        {descStr.slice(0, 125) + '...'}
      </>
    ),
  };
};
